import { useAppSelector } from '@/store/hooks';
import { selectGreenroomMeeting, selectGreenroomMeetingLoading } from '@/store/slices/project/selectors';
import { ApiConfig, Showboard, type Environment, AppName } from '@brandlive/showboard';
import blAuth from '@/connection/bl-auth/bl-auth';
import Container from '@ui/container/container';
import ComingSoon from '@/micros/coming-soon/coming-soon';
import useSegmentsFeatureFlag from './use-segments-feature-flag';

type TSegmentsProps = {
  appName?: AppName;
};

export default function Segments({ appName = 'platform' }: TSegmentsProps) {
  const greenroomMeeting = useAppSelector(selectGreenroomMeeting);
  const loadingGreenroomMeeting = useAppSelector(selectGreenroomMeetingLoading);
  const { segmentsEnabled, loading: loadingFlag } = useSegmentsFeatureFlag();
  const environment = import.meta.env.VITE_STAGE as Environment;

  if (!loadingFlag && !segmentsEnabled) return <ComingSoon label="Segments" />;

  const showboardApiConfig: ApiConfig = {
    environment,
    roomId: greenroomMeeting?.meeting?.toString() ?? '',
    accessToken: blAuth.accessToken ?? '',
    idToken: blAuth.idToken ?? '',
    blToken: blAuth.idToken ?? '',
    autoLoad: true,
  };

  return (
    <Container
      data-component="Segments"
      skLoader={
        appName === 'platform-overview'
          ? {
              height: 112,
              width: 992,
              borderRadius: 8,
              zIndex: 2,
              loading: loadingGreenroomMeeting || loadingFlag,
              design: 'GlobalCont1',
            }
          : undefined
      }
      opacity={appName === 'platform' && (loadingGreenroomMeeting || loadingFlag) ? 0 : 1}
      style={{ transition: 'opacity 300ms ease-in-out' }}
    >
      <Showboard
        apiConfig={showboardApiConfig}
        appName={appName}
        shotThumbnailWidth={169}
        greenroomState={{ meeting: greenroomMeeting ?? undefined }}
      />
    </Container>
  );
}
